/// <amd-module name="Widgets/QueryScalarWidget/QueryScalarWidgetRestClient" />
import { RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";

/**
 * TODO — Switch to the official auto-generated rest API
 *
 * The correct API is IWorkItemTrackingRestClient  from "Wit/Common/RestClient/WorkItemTracking".
 *
 * We've got to resolve this bug in order to make the switch:
 *
 *     Bug 1393013: GenClient doesn't work for ClientHeadMethodInfo in new web plat
 */
export class QueryScalarWidgetRestClient extends RestClientBase {
    /**
     * Gets the results of the query given the query ID.
     *
     * @param id - The query ID.
     * @param project - Project ID or project name
     * @param team - Team ID or team name
     */
    public async getQueryResultCount(id: string, project?: string, team?: string): Promise<number> {
        const response = await this.beginRequest<Response>({
            apiVersion: "5.1-preview.2",
            method: "HEAD",
            returnRawResponse: true,
            routeTemplate: "{project}/{team}/_apis/wit/wiql/{id}",
            routeValues: {
                project: project,
                team: team,
                id: id
            }
        });
        return Number(response.headers.get("X-Total-Count"));
    }
}

RestClients.add("QueryScalarWidgetRestClient", {
    factory: QueryScalarWidgetRestClient,
    options: {
        serviceInstanceType: "00025394-6065-48ca-87d9-7f5672854ef7"
    }
});
